import React, { useState } from "react";
import {
  faFacebookSquare,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Nav, Navbar } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const Navigation = () => {
  const location = useLocation();

  const usePathname = () => {
    return location.pathname;
  };

  const [scrolled, setScrollEffect] = useState(false);

  const listenForScrollEvent = () => {
    if (window.scrollY >= 80) {
      setScrollEffect(true);
    } else {
      setScrollEffect(false);
    }
  };
  window.addEventListener("scroll", listenForScrollEvent);

  return (
    <Navbar
      collapseOnSelect
      fixed="top"
      className={scrolled ? "navbar-filled" : "navbar"}
      expand="lg"
      variant="dark"
    >
      <Container>
        <Navbar.Brand href="/">Josh Darby</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav
            defaultActiveKey={usePathname}
            className="margin-left-right-auto"
          >
            <Nav.Link className="home-nav" href="/">
              Home
            </Nav.Link>
            <Nav.Link href="/about">About</Nav.Link>
            <Nav.Link className="btn-contact" href="/contact">
              Contact
            </Nav.Link>
            <Nav.Link className="contact-nav" href="/contact">
              Contact
            </Nav.Link>
          </Nav>
          <Nav className="social">
            <Nav.Link
              href="https://www.instagram.com/joshdarby123/"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} size="1x" color="white" />
            </Nav.Link>
            <Nav.Link
              href="https://www.facebook.com/JoshDarbyDrums/"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon
                icon={faFacebookSquare}
                size="1x"
                color="white"
              />
            </Nav.Link>
            <Nav.Link
              href="https://www.youtube.com/channel/UCM1DfS2vWcyvNDEUalicFbw"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon icon={faYoutube} size="1x" color="white" />
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
